/**
 * @generated SignedSource<<c0755b9d74feec4d2150754c3541b804>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ExcludedIPCreateFormContainer_Query$variables = {
  siteSlug: string;
};
export type ExcludedIPCreateFormContainer_QueryVariables = ExcludedIPCreateFormContainer_Query$variables;
export type ExcludedIPCreateFormContainer_Query$data = {
  readonly site: {
    readonly id: string;
  };
};
export type ExcludedIPCreateFormContainer_QueryResponse = ExcludedIPCreateFormContainer_Query$data;
export type ExcludedIPCreateFormContainer_Query = {
  variables: ExcludedIPCreateFormContainer_QueryVariables;
  response: ExcludedIPCreateFormContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteSlug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "siteSlug"
      }
    ],
    "concreteType": "Site",
    "kind": "LinkedField",
    "name": "site",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExcludedIPCreateFormContainer_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExcludedIPCreateFormContainer_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "00b95693a4fe8aea30bb7c20fc1afe4a",
    "id": null,
    "metadata": {},
    "name": "ExcludedIPCreateFormContainer_Query",
    "operationKind": "query",
    "text": "query ExcludedIPCreateFormContainer_Query(\n  $siteSlug: String!\n) {\n  site(slug: $siteSlug) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ad02faafb68166f3d3391b2e9093714";

export default node;
